export const PROJECT_CODE = 'COLLECTION'

export const MANAGER = 'MANAGER'

export const ADMIN = 'ADMIN'

export const ACCESS_TO_PROJECT = [MANAGER, ADMIN]
